/**
 * Toggles chevron icons on accordion links.
 * @param {string[]} hrefElements - Array of href selectors, e.g. ["#collapse-1"]
 * @param {Event} event - The click event
 */
export function toggleChevron(hrefElements, event) {
  hrefElements.forEach((href) => {
    const element = document.querySelector(`[href="${href}"]`);
    if (!element) return;
    const chevron = element.children[1];
    if (!chevron) return;

    if (href === event.currentTarget.hash) {
      if (chevron.classList.contains("chevron-right")) {
        chevron.classList.remove("chevron-right");
        chevron.classList.add("chevron-down");
      } else {
        chevron.classList.add("chevron-right");
        chevron.classList.remove("chevron-down");
      }
      return;
    }

    chevron.classList.remove("chevron-down");
    chevron.classList.add("chevron-right");
  });
}
